import { Link } from "react-router-dom";
import { Tent, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";

const DEPOT_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/t1i2pj9y_ChatGPT%20Image%20Sep%204%2C%202026%2C%2011_43_53%20AM.png";

export const DepotCTA = () => (
  <section data-testid="depot-cta" className="relative py-16 sm:py-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="relative overflow-hidden rounded-3xl border border-amber-500/30">
        <img src={DEPOT_IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B0C0E] via-[#0B0C0E]/90 to-[#0B0C0E]/50" />
        <div className="relative z-10 px-6 sm:px-12 py-12 sm:py-16 max-w-2xl">
          <Reveal>
            <div className="inline-flex items-center gap-2 rounded-full bg-amber-500/15 border border-amber-500/30 px-3 py-1 text-xs font-mono uppercase tracking-widest text-amber-500">
              <Tent className="w-3.5 h-3.5" /> Nyhet för förare
            </div>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl font-black uppercase tracking-tight text-white leading-[1.03]">
              Boka din depåplats
            </h2>
            <p className="mt-4 text-lg text-white/70">
              Reservera din depåplats till Novemberkåsan 2026 direkt online. Snabbt, enkelt – och först till kvarn.
            </p>
            <Link to="/depa-bokning" data-testid="depot-cta-btn" className="mt-7 inline-flex items-center gap-2 rounded-full bg-amber-500 px-7 py-4 text-sm font-bold uppercase tracking-widest text-black hover:bg-amber-400 transition-colors amber-glow">
              Boka depåplats <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
